import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { footerLinks } from '../../utils/homeData';
import LegalDialog from '../LegalDialog/LegalDialog';
import './Footer.css';

const INFOBLOOM_WHATSAPP_URL = 'https://wa.me/2349014088590?text=Hi%2C%20I%27m%20interested%20in%20becoming%20a%20course%20creator%20on%20Infobloom.';

export default function Footer() {
  const [legalSlug, setLegalSlug] = useState(null);
  const { t } = useLanguage();

  return (
    <footer className="udemy-footer">
      <div className="udemy-footer-main">
        <div className="udemy-footer-main-inner">
          <div className="udemy-footer-col">
            <h4 className="udemy-footer-heading">Explore top skills and certifications</h4>
            <p className="udemy-footer-subheading">Top categories</p>
            <ul>
              {footerLinks.topCategories.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
            <p className="udemy-footer-subheading">Certifications by role</p>
            <ul>
              {footerLinks.certificationsByRole.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
          </div>
          <div className="udemy-footer-col">
            <p className="udemy-footer-subheading">Web Development</p>
            <ul>
              {footerLinks.webDevelopment.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
            <p className="udemy-footer-subheading">Data Science</p>
            <ul>
              {footerLinks.dataScience.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
          </div>
          <div className="udemy-footer-col">
            <p className="udemy-footer-subheading">IT Certifications</p>
            <ul>
              {footerLinks.itCertifications.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
            <p className="udemy-footer-subheading">Communications</p>
            <ul>
              {footerLinks.communications.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
          </div>
          <div className="udemy-footer-col">
            <p className="udemy-footer-subheading udemy-footer-brand">Learnwithinfobloom</p>
            <a href={INFOBLOOM_WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="udemy-footer-teach-cta">
              {t('navbar.teach')}
            </a>
            <ul>
              {footerLinks.about.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
            <p className="udemy-footer-subheading">Business Intelligence & Analytics</p>
            <ul>
              {footerLinks.businessIntelligence.map((item) => (
                <li key={item}><Link to="/">{item}</Link></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="udemy-footer-bottom">
        <div className="udemy-footer-bottom-inner">
          <span className="udemy-footer-logo-text">Learnwithinfobloom</span>
          <a href={INFOBLOOM_WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="udemy-footer-teach-inline">{t('navbar.teach')}</a>
          <span className="udemy-footer-copy">© 2026 <span className="udemy-footer-brand-inline">Learnwithinfobloom</span>, Inc.</span>
          <button type="button" className="udemy-footer-legal udemy-footer-legal-btn" onClick={() => setLegalSlug('terms')}>Terms</button>
          <button type="button" className="udemy-footer-legal udemy-footer-legal-btn" onClick={() => setLegalSlug('privacy')}>Privacy Policy</button>
          <button type="button" className="udemy-footer-legal udemy-footer-legal-btn" onClick={() => setLegalSlug('accessibility')}>Accessibility Statement</button>
          <button type="button" className="udemy-footer-legal udemy-footer-legal-btn" onClick={() => setLegalSlug('cookies')}>Cookie settings</button>
          <button type="button" className="udemy-footer-legal udemy-footer-legal-btn" onClick={() => setLegalSlug('sitemap')}>Sitemap</button>
        </div>
      </div>
      <LegalDialog isOpen={legalSlug != null} onClose={() => setLegalSlug(null)} slug={legalSlug} />
    </footer>
  );
}
